import { useQuery } from '@tanstack/react-query'

import api from '@/api'

const PRICES_KEY = 'prices'

export const usePrices = () => {
  return useQuery({
    queryKey: [PRICES_KEY],
    queryFn: async () => (await api.getPrices()).data,
  })
}
